import { useState } from "react";
import { Scissors } from "lucide-react";
import { toast } from "sonner";
import { api, gbp, errorMessage } from "../../lib/api";

// Names merged into one product at ONE supplier: separate a wrongly merged name (or all of them).
export default function MergedNames({ members, displayName, onChanged, testId = "merged-names" }) {
  const [busy, setBusy] = useState(null);
  const separate = async (ids) => {
    setBusy(ids.join(","));
    try {
      const { data } = await api.post("/product-matches/unmerge", { product_ids: ids });
      toast.success(data.separated === 1 ? "Separated — shown as its own product again and remembered as different." : `${data.separated} names separated into their own products.`);
      onChanged?.();
    } catch (e) { toast.error(errorMessage(e)); } finally { setBusy(null); }
  };
  return (
    <div className="rounded-lg border border-violet-200 bg-violet-50/50 p-2.5 text-xs space-y-1" data-testid={testId}>
      <p className="font-semibold text-violet-800">Merged names shown as “{displayName}” — wrong one? Separate it.</p>
      <ul className="divide-y divide-violet-100">
        {members.map((m) => (
          <li key={m.id} className="flex items-center gap-2 py-1" data-testid={`${testId}-row-${m.id}`}>
            <span className="min-w-0 flex-1 truncate text-slate-800">{m.description}{m.pack_size ? <span className="text-slate-400"> · {m.pack_size}</span> : null}</span>
            {m.latest_price != null && <span className="font-mono text-slate-500 shrink-0">{gbp(m.latest_price)}</span>}
            <button type="button" onClick={() => separate([m.id])} disabled={busy !== null} className="inline-flex items-center gap-1 rounded-full border border-rose-200 bg-white px-2 py-0.5 font-semibold text-rose-700 hover:bg-rose-50 disabled:opacity-50 shrink-0" data-testid={`${testId}-separate-${m.id}`}><Scissors className="h-3 w-3" /> Separate</button>
          </li>
        ))}
      </ul>
      {members.length > 2 && <button type="button" onClick={() => separate(members.map((m) => m.id))} disabled={busy !== null} className="text-rose-700 font-semibold hover:underline disabled:opacity-50" data-testid={`${testId}-separate-all`}>Separate all {members.length} names</button>}
    </div>
  );
}
